export default {
  description:
    'Lade die Dokumente hoch, mit denen wir dein Unternehmen verifizieren. Pflichtdokumente sind markiert, die optionalen kannst du jetzt oder später hinzufügen.',
  missing_one:
    'Ein Pflichtdokument fehlt noch. Du kannst trotzdem weitermachen: Dieser Schritt bleibt offen, bis es hochgeladen ist.',
  missing_other:
    'Es fehlen noch {{count}} Pflichtdokumente. Du kannst trotzdem weitermachen: Dieser Schritt bleibt offen, bis sie hochgeladen sind.',
  buttons: {
    back: 'Zurück',
    next: 'Weiter',
    finish_later: 'Später abschließen',
  },
};
